export const OPERATIONS_BESOIN = [
  { value: 'location', label: 'À louer' },
  { value: 'achat', label: 'À acheter' },
];

export const TYPES_BESOIN = [
  { value: 'maison', label: 'Maison' },
  { value: 'appartement', label: 'Appartement' },
  { value: 'villa', label: 'Villa' },
  { value: 'terrain', label: 'Terrain' },
  { value: 'bureau', label: 'Bureau' },
  { value: 'commerce', label: 'Commerce' },
  { value: 'immeuble', label: 'Immeuble' },
  { value: 'autre', label: 'Autre' },
];

export const STATUTS_BESOIN = {
  en_attente: 'En validation',
  publie: 'Publié',
  rejete: 'Rejeté',
  satisfait: 'Besoin satisfait',
  expire: 'Expiré',
};

export const labelFor = (options, value) => options.find(option => option.value === value)?.label || value;

export const formatGNF = (value) => {
  if (value === null || value === undefined || value === '') return null;
  return `${new Intl.NumberFormat('fr-GN', { maximumFractionDigits: 0 }).format(Number(value))} GNF`;
};

export const formatBudget = (besoin) => {
  const min = formatGNF(besoin.budgetMin);
  const max = formatGNF(besoin.budgetMax);
  if (min && max) return `${min} – ${max}`;
  if (max) return `Jusqu'à ${max}`;
  if (min) return `À partir de ${min}`;
  return 'Budget à discuter';
};

export const whatsappLink = (besoin) => {
  const raw = besoin.whatsapp || besoin.telephone || '';
  let number = String(raw).replace(/\D/g, '');
  if (number && !number.startsWith('224')) number = `224${number}`;
  if (!number) return null;
  const message = `Bonjour, je réponds à votre recherche « ${besoin.titre} » publiée sur Démarcheur.`;
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
};

export const joursRestants = (expireAt) => {
  if (!expireAt) return null;
  return Math.max(0, Math.ceil((new Date(expireAt).getTime() - Date.now()) / 86400000));
};
